import { useState, useEffect } from 'react'
import { TooltipV2Props } from 'builder/components/Tooltip/types'
import { Tooltip, TooltipIconWrapper, TooltipIcon, TooltipValue, Container } from './styles'

const TOOLTIP_TIMEOUT = 3800
const LOCAL_STORAGE_KEY = 'change_template_tooltip_seen'

type Props = {
  children: React.ReactNode
  tooltip: string
} & TooltipV2Props

export const TooltipInfoWrapper = ({ children, tooltip, ...props }: Props) => {
  const isTooltipSeen = localStorage.getItem(LOCAL_STORAGE_KEY)
  const [isTooltipVisible, setIsTooltipVisible] = useState(!isTooltipSeen)

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!isTooltipSeen) {
        setIsTooltipVisible(false)
        localStorage.setItem(LOCAL_STORAGE_KEY, 'true')
      }
    }, TOOLTIP_TIMEOUT)
    return () => clearTimeout(timeout)
  }, [isTooltipSeen])

  return (
    <Tooltip
      multiline
      {...props}
      visible={isTooltipVisible}
      value={
        <TooltipValue>
          <TooltipIconWrapper>
            <TooltipIcon />
          </TooltipIconWrapper>
          <span>{tooltip}</span>
        </TooltipValue>
      }
    >
      <Container>{children}</Container>
    </Tooltip>
  )
}
